import { useAppState } from 'Context/AppContext/AppContext'
import { DialogVariant } from 'TypeDefs/AppContext'
import { UpgradeModal } from 'Components/Pages/Upgrade/UpgradeModal/UpgradeModal'
import { useShowUpgradeModalDialog } from 'Hooks/useGlobalDialogDispatchers'
import { TrialEndDialog } from './TrialEndDialog'

export const GlobalDialog = () => {
  const {
    ui: { dialog },
  } = useAppState()
  const dispatchShowUpgradeModal = useShowUpgradeModalDialog()

  if (!dialog?.isVisible || !dialog.variant) {
    return null
  }

  switch (dialog.variant) {
    case DialogVariant.TRIAL_END:
      return <TrialEndDialog />
    case DialogVariant.UPGRADE_MODAL_DIALOG:
      return (
        <UpgradeModal
          openUpgradeDialog={dialog.isVisible}
          setOpenUpgradeDialog={dispatchShowUpgradeModal}
        />
      )
    default:
      return null
  }
}
